import { Box } from 'src/design/atoms/Box';
import { IconCheck, IconCopy } from '@tabler/icons-react';
import { useClipboard } from '@mantine/hooks';
import React from 'react';
import { BasicActionIcon } from 'src/design/atoms/BasicActionIcon';
import classes from './chat.module.css';

const nodeToText = (node: React.ReactNode): string => {
  if (typeof node === 'string') return node;
  if (typeof node === 'number') return String(node);
  if (Array.isArray(node)) return node.map(nodeToText).join('');
  if (React.isValidElement(node)) {
    return nodeToText((node.props as { children?: React.ReactNode }).children);
  }
  return '';
};

/** @registry Markdown `pre` renderer for chat replies: the code block plus a hover-revealed copy-code button. */
export const ChatCodeBlock: React.FC<React.HTMLAttributes<HTMLPreElement>> = ({
  children,
  ...props
}) => {
  const clipboard = useClipboard({ timeout: 1500 });
  const code = nodeToText(children);

  return (
    <Box className={classes.codeBlock}>
      <Box component="pre" {...props}>
        {children}
      </Box>
      <Box className={classes.codeCopy}>
        <BasicActionIcon
          size="sm"
          variant="subtle"
          color="gray"
          label={clipboard.copied ? 'Copied' : 'Copy code'}
          onClick={() => clipboard.copy(code)}
        >
          {clipboard.copied ? <IconCheck size={14} /> : <IconCopy size={14} />}
        </BasicActionIcon>
      </Box>
    </Box>
  );
};
